import Canvaselement from '../classes/canvas.js';


class Doek {

    constructor(plaatje, breedte, hoogte) {
        this.plaatje = plaatje;
        this.breedte = breedte;
        this.hoogte = hoogte;
        this.element = this.createDoek();
    }

    createDoek() {
        var doek = document.createElement('div');
        var doekWrapper = document.createElement('div');
        doekWrapper.id = 'doekwrapper';

        doek.id = 'doek';
        doek.className = 'hoofdbeeld';

        doek.style.width = this.breedte + 'px'; 
        doek.style.height = this.hoogte + 'px';
        doek.style.backgroundImage = 'url(' + this.plaatje + ')';

        doekWrapper.appendChild(doek);
        document.body.appendChild(doekWrapper);

        return doek;

}
}

window.Doek = Doek;

export default Doek;


